import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, Teleport as _Teleport, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fc653104")

_pushScopeId("data-v-fc653104")
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "window" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.content.opened)
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "body"
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", {
            class: "hidden",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }),
          _createVNode("div", _hoisted_2, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.content.component), _ctx.content.componentOptions, null, 16)),
            _renderSlot(_ctx.$slots, "default", {
              initTab: _ctx.content.componentOptions?.initTab
            }, undefined, true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})